import React, { ReactNode } from 'react';
import styles from './assets/report-screen.module.scss';
import classNames from 'classnames';
import ReportPayrollsGrid from './components/ReportPayrollsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';

import RoleLayout from 'src/components/layout/RoleLayout';
import { IReportPayroll } from 'src/types/reportPayroll';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<IReportPayroll>;
}

export interface DispatchProps {
    getDataCsv: (params: QueryParams) => void;
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ReportPayrollsList extends React.Component<Props> {
    //componentDidMount() {}

    public render(): ReactNode {
        const { data, getData, getDataCsv } = this.props;

        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={`pageHeading`}>
                    <h2 className={classNames(styles.pageHeadingTitle, 'pageHeadingTitle')}>
                        PAYROLL REPORTS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                </div>
                <div className={classNames(styles.list)}>
                    <ReportPayrollsGrid data={data} getDataCsv={getDataCsv} getData={getData} />
                </div>
            </RoleLayout>
        );
    }
}

export default ReportPayrollsList;
